import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { getMyCopierStrategies, StrategyList } from "@/services/getMyCopierStrategies";


export const fetchStrategies = createAsyncThunk(
    "strategy/fetchStrategies",
    async (
        { pageNumber }: { pageNumber: number },
        { rejectWithValue }
    ) => {
        try {
            const data = await getMyCopierStrategies();
            return data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
interface StrategyState {
    strategies: StrategyList[];
    loading: boolean
}

const initialState: StrategyState = {
    strategies: [],
    loading: false,
};

export const StrategySlice = createSlice({
    name: "strategies_slice",
    initialState,
    reducers: {
        resetPageAndStrategies: (state) => {
            state.strategies = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStrategies.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchStrategies.fulfilled, (state, action: PayloadAction<StrategyList[]>) => {
                state.loading = false;
                const newStrategies = action.payload;
                const ids = new Set(state.strategies.map((strategy) => strategy.strategy_id));
                state.strategies = [...state.strategies, ...newStrategies?.filter((strategy) => !ids.has(strategy.strategy_id))];
            })
            .addCase(fetchStrategies.rejected, (state, action) => {
                state.loading = false;
            });
    },
});

export const {
    resetPageAndStrategies
} = StrategySlice.actions;

export default StrategySlice.reducer;
